// src/redux/branding/selectors.ts
import { createSelector } from '@reduxjs/toolkit';
import { BrandingState, type } from './state';

const featureStateSelector = (state: { [type]: BrandingState }) => state[type];

export const brandingSelector = createSelector(
    featureStateSelector,
    state => state
);

export const brandingPrimarySelector = createSelector(
    featureStateSelector,
    state => state.primary
);

export const brandingSecondarySelector = createSelector(
    featureStateSelector,
    state => state.secondary
);

export const brandingNameSelector = createSelector(
    featureStateSelector,
    state => state.name
);

export const brandingLogoUrlSelector = createSelector(
    featureStateSelector,
    state => state.logoUrl
);

export const brandingCurrencyPrefixSelector = createSelector(
    featureStateSelector,
    state => state.currencyPrefix
);

export const brandingLoadedSelector = createSelector(
    featureStateSelector,
    state => state.loaded
);

export const brandingErrorSelector = createSelector(
    featureStateSelector,
    state => state.error
);
